import { useLoader } from "common/components/WithLoader/useLoader";
import { isEmpty } from "lodash/fp";
import { COVER_LABELS_INSTRUCTION, LabelPlacement } from "prep/create/PrepInstructions/PrepInstructionsTypes";
import { selectPrepJob, setPrepJob } from "prep/store";
import { selectConsolidatedPrepInstructions } from "prep/store/selectors/selectConsolidatedPrepInstructions";
import { inferLabelPlacement } from "prep/util/inferLabelPlacement";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CreateTransferLoader } from "transfers/create/CreateTransferLoader.types";

export const useTransferSelectPrepInstructions = () => {
  const isLoading = useLoader(CreateTransferLoader.NextStepLoader);
  const prepJob = useSelector(selectPrepJob);
  const selectedPrepInstructions = useSelector(selectConsolidatedPrepInstructions);
  const dispatch = useDispatch();

  const [isCoverLabelsChecked, setIsCoverLabelsChecked] = useState<boolean>(
    selectedPrepInstructions.includes(COVER_LABELS_INSTRUCTION)
  );
  const [labelPlacement, setLabelPlacement] = useState<LabelPlacement | undefined>(
    inferLabelPlacement(selectedPrepInstructions)
  );

  const handleCoverLabelsChange = () => {
    const isUpdatedCoverLabelsChecked = !isCoverLabelsChecked;
    setIsCoverLabelsChecked(isUpdatedCoverLabelsChecked);
    buildPrepNote(isUpdatedCoverLabelsChecked, labelPlacement);
  };

  const handleLabelSelect = (selectedOption) => {
    const updatedLabelPlacement = selectedOption?.value;
    setLabelPlacement(updatedLabelPlacement);
    buildPrepNote(isCoverLabelsChecked, updatedLabelPlacement);
  };

  const labelPlacementOptions = Object.values(LabelPlacement).map((val) => ({ label: val, value: val }));

  const buildPrepNote = (coverLabelsChecked: boolean, placement: LabelPlacement | undefined) => {
    const instructions: string[] = [];

    if (coverLabelsChecked) {
      instructions.push(COVER_LABELS_INSTRUCTION);
    }

    if (placement) {
      instructions.push(`Paste labels at ${placement}`);
    }

    const updatedNote = isEmpty(instructions) ? undefined : instructions.join(" | ");

    if (prepJob) {
      const { note, ...prepJobDetails } = prepJob;
      dispatch(setPrepJob(updatedNote ? { ...prepJobDetails, note: updatedNote } : prepJobDetails));
    }
  };

  return {
    isLoading,
    isCoverLabelsChecked,
    labelPlacement,
    handleCoverLabelsChange,
    handleLabelSelect,
    labelPlacementOptions,
  };
};
